import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/layout/Page";
import { FaTrash } from '@react-icons/all-files/fa/FaTrash'
import Button from "../../components/forms/Button";
import "./index.scss";
import { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../services/requestService";
import { Checkbox, Table, Tag } from "antd";
import { AnimatePresence, motion } from "framer-motion";
import { BUTTON_VARIANT_SECONDARY } from "../../components/forms/Button/constants";
import { FiFileText } from '@react-icons/all-files/fi/FiFileText'
import AutoApplyModal from "./Components/AutoApplyModal";
import Stats from "./Components/Stats";
import JobItem from "../DashboardPage/Components/JobItem";
import { setModalState, triggerApplicationModal, triggerCoverLetterModal, triggerResumeEditor } from "../../store/reducers/Modal/actions";
import { push } from "connected-react-router";
import { JOB_ITEM_VARIANT_SAVED_JOBS } from "../DashboardPage/Components/JobItem/constants";
import { fetchSavedJobs, refreshStats, setSavedJobs } from "../../store/reducers/Jobs/actions";
import { FaPlus } from "@react-icons/all-files/fa/FaPlus";
import { getUserData } from "../../store/reducers/Auth/actions";
import StatusPicker from "../DashboardPage/Components/StatusPicker";
import { FaEye } from "@react-icons/all-files/fa/FaEye";
import { FaMagic } from "@react-icons/all-files/fa/FaMagic";
import { getFriendlyTime } from "../../services/textService";
import { isMobile } from "../../services/clientService";
import { hasCredits } from "../../services/billingService";
import { reportEvent, trackServerEvent } from "../../services/analyticsService";
import { getTaskStatus } from "../../services/savedJobService";
import { FaLock } from "@react-icons/all-files/fa/FaLock";
const SavedJobs = props => {
    
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const { isSavedJobsLoading, savedJobs } = useSelector(({ JobsReducer }) => JobsReducer);
    const [selectedItems, setSelectedItems] = useState([])
    const [isGenerateResumeLoading, setIsGenerateResumeLoading] = useState(false)
    const [coverLetterLoading, setCoverLetterLoading] = useState()
    const [feed, setFeed] = useState('pending')
    const didSelectAll = savedJobs.length > 0 && savedJobs.length === selectedItems.length
    const selectedKeysObj = {}
    selectedItems.forEach(item => {
        selectedKeysObj[item._id] = true;
    })
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchSavedJobs({feed}))
    }, [])

    useEffect(() => {
        dispatch(fetchSavedJobs({feed}))
    }, [feed])

    const onJobChange = (jobId, key, val, savedJobId) => {
        let selectedSavedJob
        const updatedJobs = savedJobs.map(job => {
            if (savedJobId && savedJobId === job._id) {
                job[key] = val;
                selectedSavedJob = job;
            }
            else if (!savedJobId && (jobId === job?.job?._id)) {
                if (job.job) {
                    job.job[key] = val;
                }

                selectedSavedJob = job;
            }
            return job;
        })
        dispatch(setSavedJobs(updatedJobs))
        if (key === 'checked' && val === true) {
            setSelectedItems([...selectedItems, selectedSavedJob])
        }
        else if (key === 'checked' && val === false) {
            setSelectedItems([...selectedItems.filter(a => a.job._id !== jobId && a._id !== jobId)])
        }
    }

    const onSavedJobRemove = async (savedJobId) => {
        await postRequest('saved-job/delete', { savedJobId: savedJobId })
        dispatch(setSavedJobs([...savedJobs.filter(job => {
            return job._id !== savedJobId
        })]))
        dispatch(refreshStats())
    }
    const onSelectAll = () => {
        setSelectedItems(didSelectAll ? [] : savedJobs)
    }

    const onCreateKitClick = async (savedJob) => {
        dispatch(triggerApplicationModal({ savedJob }))
    }
    const onGenerateResume = async (savedJob) => {
        let res;
        if (!savedJob.resume) {

            setIsGenerateResumeLoading(savedJob._id)
            res = await postRequest('application/generate-resume', { savedJobId: savedJob._id })
            dispatch(getUserData())
            setIsGenerateResumeLoading(false)
        }
        dispatch(triggerResumeEditor({ savedJob: res?.data?.savedJob || savedJob }))
        // dispatch(setModalState('isResumeEditorModalOpen', true, { savedJob: res?.data?.savedJob || savedJob }))
    }
    const onGenerateCoverLetter = async (savedJob) => {
        setCoverLetterLoading(savedJob._id)
        const res = await postRequest('application/generate-cover', { savedJobId: savedJob._id })
        dispatch(triggerCoverLetterModal({ savedJob: res.data.savedJob }))
        setCoverLetterLoading()
    }
    const onViewCoverLetter = (savedJob) => {
        dispatch(triggerCoverLetterModal({ savedJob }))

    }
    const onUpgradeClick = () => {
        reportEvent('upgrade_btn', 'click', { source: 'savedJobDashboard' })
        dispatch(setModalState('isUpgradeModalOpen', true))
    }
    const getTableColumns = () => {
        let cols = [
            isMobile() ? null : {
                title: 'Saved at',
                dataIndex: 'createdAt',
                render: item => getFriendlyTime(item)
            },
            isMobile() ? null : {
                width: 50,
                title: 'Status',
                render: item => <StatusPicker savedJob={item} />
            },
            {
                title: 'Job',
                width: 300,
                render: item => {
                    const job = item.jobDetails?.jobTitle ? item.jobDetails : item.job;
                    return (
                        <div>
                            {`${job.jobTitle} at ${job.company}`}
                            {/* <Tag className="tasks-left">{`${getTaskStatus(item.tasks).left} tasks left`}</Tag> */}
                        </div>
                    )
                }
            },
            {
                title: 'Application Kit',
                render: item => {
                    if (!item.resume && !hasCredits(userDetails)) {
                        return (
                            <Button className="action-btn" variant={BUTTON_VARIANT_SECONDARY}
                                onClick={() => onUpgradeClick()}
                            >
                                <FaMagic />
                                Upgrade</Button>
                        )
                    }

                    return (
                        <Button className="action-btn" variant={BUTTON_VARIANT_SECONDARY} onClick={() => onCreateKitClick(item)}>
                            {item.resume ? <FaEye /> : <FaMagic />}
                            {item.resume ? 'View' : 'Generate'}
                        </Button>
                    )
                }
            },
            isMobile() ? null : {
                title: 'Resume',
                render: item => {
                    if (!item.resume) return null;
                    if (!item.resume && !hasCredits(userDetails))
                        return (
                            <Button className="action-btn" variant={BUTTON_VARIANT_SECONDARY}
                                onClick={() => onUpgradeClick()}
                            >
                                <FaMagic />
                                Upgrade</Button>
                        )
                    return item.resume ? (
                        <Button className="action-btn" variant={BUTTON_VARIANT_SECONDARY} onClick={() => onGenerateResume(item)}>
                            <FaEye />
                            View</Button>
                    ) : (
                        <Button className="action-btn" variant={BUTTON_VARIANT_SECONDARY}
                            loading={isGenerateResumeLoading === item._id} onClick={() => onGenerateResume(item)}
                        >
                            <FaMagic />
                            Generate</Button>
                    )

                }
            },

        ]
        if (!isMobile()) {
            cols.push({
                title: 'Cover Letter',
                render: item => {
                    if (!item.application?.coverLetterText) return null;
                    const isEligibleForCoverLetter = hasCredits(userDetails)
                    const didGenerateCoverLetter = !!item.application?.coverLetterText
                    if (didGenerateCoverLetter) return (
                        <Button className="action-btn" variant={BUTTON_VARIANT_SECONDARY} onClick={() => onViewCoverLetter(item)}>
                            <FaEye />
                            View</Button>
                    )
                    else if (isEligibleForCoverLetter) return (
                        <Button className="action-btn" variant={BUTTON_VARIANT_SECONDARY}
                            loading={coverLetterLoading === item._id
                            } onClick={() => onGenerateCoverLetter(item)}
                        >
                            <FaMagic />
                            Generate</Button >
                    )


                    return (
                        <Button className="action-btn" variant={BUTTON_VARIANT_SECONDARY}
                            onClick={() => onUpgradeClick()}
                        >
                            <FaMagic />
                            Upgrade</Button>
                    )
                },
            })
        }
        return cols.filter(a => !!a);
    }
    return (
        <Page className="saved-jobs">
            <Stats variant="savedJobs" />
            <div className="saved-jobs-header">
                <div><h1>Job Tracker</h1></div>
                <Button onClick={() => {
                    if (!hasCredits(userDetails)) {
                        trackServerEvent('import-job-click-show-upgrade')
                        dispatch(setModalState('isUpgradeModalOpen', true))
                    }
                    else {
                        trackServerEvent('import-job-click-show-import')
                        dispatch(setModalState('isImportJobModalOpen', true))
                    }
                }}>
                    {hasCredits(userDetails) ? <FaPlus /> : <FaLock />}
                    Import Job</Button>
            </div>

            <br /><br />
            <div className="jobs">
                {!savedJobs?.length && !isSavedJobsLoading && <div className="empty-state">
                    <FiFileText />
                    <div className="title">Let’s get started 🎉</div>
                    <div className="subtitle">Ready to make your next move? Start your journey by exploring top job opportunities.</div>
                    <div className="buttons">

                        <Button onClick={() => dispatch(push('/search'))}>Search Jobs ✨</Button>
                        <Button variant={BUTTON_VARIANT_SECONDARY} onClick={() => dispatch(setModalState('isImportJobModalOpen', true))}>Import Job</Button>
                    </div>
                </div>}
                {selectedItems.length ? <div className="checked-items-menu">
                    <Checkbox checked disabled />
                    <span className="items-count">{selectedItems.length}</span>
                    <span className="items-label">{` items`}</span>
                    <span className="select-all" onClick={() => onSelectAll()}
                    >{didSelectAll ? 'Deselect All' : 'Select all'}</span>
                    <span className="save-btn" style={{ textDecoration: 'underline', marginLeft: 15, display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    >
                        <FaTrash style={{ marginRight: 6 }} />
                        {`Remove ${selectedItems.length} Jobs`}
                    </span>
                </div> : null}
                {savedJobs.length > 0 && <Table dataSource={savedJobs} className="jobs-table"
                    columns={getTableColumns()}
                />}
                {false && <AnimatePresence>
                    {savedJobs.map((savedJob) => {
                        return (
                            <motion.div
                                key={savedJob._id}
                                initial={{ opacity: 0, y: 20 }}           // Enter: fade in + slide up
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}             // Exit: fade out + move further up
                                transition={{ duration: 0.3 }}
                            >
                                <JobItem variant={JOB_ITEM_VARIANT_SAVED_JOBS} key={savedJob._id}
                                    checked={!!selectedKeysObj[savedJob._id]}
                                    savedJob={savedJob}
                                    job={savedJob?.jobDescriptionText ? savedJob.jobDetails : savedJob.job} isSaved={true} onJobChange={onJobChange}
                                    onCreateKitClick={onCreateKitClick} onRemoveClick={onSavedJobRemove}
                                    onGenerateResume={onGenerateResume}
                                    isGenerateResumeLoading={isGenerateResumeLoading}
                                />
                            </motion.div>
                        )
                    })}
                </AnimatePresence>}


            </div>
        </Page>
    )
}

export default SavedJobs